import { Stack, Typography, useTheme } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { getFilteredCandidateListByJobId } from 'src/services/candidate.service';
import Iconify from 'src/components/iconify';
import PropTypes from 'prop-types';
import PreScreenFilter from './filter-sections/prescreen-filter';
import ScoreFilters from './filter-sections/score-filters';
import ScreeningFilters from './filter-sections/screening-filters';
import SourceFilter from './filter-sections/source-filter';
import StatusFilter from './filter-sections/status-filter';
import TagsFilter from './filter-sections/tags-filters';

const useStyles = makeStyles(theme => ({
  footerDiv: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
  },
  footerDivFirst: {
    flexDirection: 'row',
    gap: '12px',
    alignItems: 'center',
  },
  filterForSelect: {
    // color:theme.palette.content.accent1,
    // background:theme.palette.background.primaryAccent2,
    // borderRadius: 36,
  },
  idealResponseDiv: {
    content: 'none',
    background: theme.palette.content.accent2,
    height: '80px',
    borderRight: `2px dashed ${theme.palette.content.primaryBlack3}`,
    borderLeft: `2px dashed ${theme.palette.content.primaryBlack3}`,
    position: 'relative',
    top: '-15vh',
    zIndex: 0,
    alignItems: 'center',
  },
}));

export default function FiltersDialog({
  open,
  setOpen,
  filters,
  setShowFilterResults,
  organization_id,
  jobId,
  setFilteredCandidateList,
  setShowNavbar,
}) {
  // hooks
  const classes = useStyles();
  const theme = useTheme();

  // variables
  const filtersObj = JSON.parse(filters || '{}');

  // states
  const [filterAPICode, setFilterAPICode] = useState({});
  const [reset, setReset] = useState(false);

  const FiltersMap = filtersObj['APPLIED'];

  const [resultsCount, setResultsCount] = useState(
    FiltersMap?.summary?.total_candidates,
  );

  // functions
  const candidateFilterFunctionCaller = async ({ argument }) => {
    const dum = { ...filterAPICode };

    Object.values(filterAPICode)?.map((item, index) => {
      if (typeof item !== 'object') {
        dum[Object.keys(filterAPICode)?.[index]] = {
          int_value: 1,
        };
      }
    });

    const payload = {
      filter_map: dum,
    };

    if (argument?.count_only) payload.count_only = true;

    const res = await getFilteredCandidateListByJobId(
      organization_id,
      jobId,
      payload,
    );

    return res;
  };

  // effects

  useEffect(() => {
    setFilterAPICode({});
  }, [reset]);

  useEffect(() => {
    const caller = async () => {
      const res = await candidateFilterFunctionCaller({ count_only: true });
      setResultsCount(res?.body?.total_candidates);
    };

    if (filterAPICode && Object.keys(filterAPICode)?.length > 0) caller();
    else setResultsCount(FiltersMap?.summary?.total_candidates);
  }, [filterAPICode, organization_id, jobId]);

  // const STAGE_UI_MAPPING = {
  //     [SOURCED]: "Applied",
  //     [APPLIED]: "Applied",
  //     [SHORTLISTED]: "Applied",
  //     [AI_INTERVIEW]: "AI Interview",
  //     [NOT_SHORTLISTED]: "Needs Review",
  //     [INPERSON_INTERVIEW]: "In-person Interview",
  //     [HIRED]: "Hired",
  //     [REJECTED]: "Rejeced"
  // }

  const handleViewResults = async () => {
    try {
      const data = await candidateFilterFunctionCaller({ count_only: true });
      if (data !== undefined && data !== null && data.success) {
        const _candidates = data.body.candidates.map(candidate => {
          const _data = {
            id: candidate.candidate_info.user_id,
            interviewId: candidate.interview_details?.interview_id,
            rank: candidate.interview_details
              ? candidate.interview_details.rank
              : null,
            name: candidate.candidate_info.name,
            email: candidate.candidate_info.email,
            mobNo: candidate.candidate_info.phone_number,
            stage: candidate.job_candidate_stage,
            currentRole: candidate.candidate_info?.current_role || '',
            currentOrg: candidate.candidate_info?.current_org || '',
            aiRecommendation: candidate.ai_recommendation,
            screeningStatus: candidate.screening_status,
            tags: candidate.candidate_info.tags,
            source: candidate.candidate_info.candidate_source,
            preScreeningQualified: candidate.pre_screening_qualified,
            screeningQualified: candidate.screening_qualified,
            score: candidate.interview_details
              ? candidate.interview_details.total_score
              : null,
            isEmailSent: candidate.interview_details
              ? candidate.interview_details.email_sent
              : null,
            updatedAt: candidate.updated_at,
          };
          return _data;
        });

        setFilteredCandidateList(_candidates);
        setShowNavbar(false);
        setShowFilterResults(true);
        setOpen(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Dialog
      maxWidth="md"
      fullWidth
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="scroll-dialog-title">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="Space-between"
        >
          <Typography variant="h3">Filter Candidates</Typography>
          <Iconify
            sx={{ cursor: 'pointer' }}
            color={theme.palette.background.primaryRed1}
            icon="tabler:x"
            onClick={() => {
              setOpen(false);
            }}
          />
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack spacing="24px">
          {FiltersMap?.status &&
            Object.keys(FiltersMap?.status)?.length > 0 && (
              <Stack spacing="12px">
                <Typography variant="subtitle1">Status</Typography>
                <Stack spacing="8px">
                  <StatusFilter
                    FiltersMap={FiltersMap}
                    reset={reset}
                    filterAPICode={filterAPICode}
                    setFilterAPICode={setFilterAPICode}
                  />
                </Stack>
              </Stack>
            )}

          {FiltersMap?.candidate_source &&
            Object.keys(FiltersMap?.candidate_source)?.length > 0 && (
              <Stack spacing="12px">
                <Typography variant="subtitle1">Source</Typography>
                <Stack spacing="8px">
                  <SourceFilter
                    FiltersMap={FiltersMap}
                    reset={reset}
                    filterAPICode={filterAPICode}
                    setFilterAPICode={setFilterAPICode}
                  />
                </Stack>
              </Stack>
            )}

          {FiltersMap?.tags && Object.keys(FiltersMap?.tags)?.length > 0 && (
            <Stack spacing="12px">
              <Typography variant="subtitle1">Tags</Typography>
              <Stack spacing="8px">
                <TagsFilter
                  FiltersMap={FiltersMap}
                  reset={reset}
                  filterAPICode={filterAPICode}
                  setFilterAPICode={setFilterAPICode}
                />
              </Stack>
            </Stack>
          )}

          {FiltersMap?.pre_screening &&
            Object.keys(FiltersMap?.pre_screening)?.length > 0 && (
              <Stack spacing="12px">
                <Typography variant="subtitle1">Pre screening</Typography>
                <Stack>
                  {Object.values(FiltersMap?.pre_screening)?.map(
                    (item, index) => (
                      <PreScreenFilter
                        key={index}
                        item={item}
                        FiltersMap={FiltersMap}
                        reset={reset}
                        setFilterAPICode={setFilterAPICode}
                      />
                    ),
                  )}
                </Stack>
              </Stack>
            )}

          {FiltersMap?.status &&
            Object.keys(FiltersMap?.status)?.length > 0 && (
              <Stack spacing="22px">
                <Typography variant="subtitle1">Screening</Typography>
                <ScreeningFilters
                  setFilterAPICode={setFilterAPICode}
                  FiltersMap={FiltersMap}
                  reset={reset}
                />
              </Stack>
            )}

          {FiltersMap?.interview_score &&
            Object.keys(FiltersMap?.interview_score)?.length > 0 && (
              <Stack spacing="12px">
                <Typography variant="subtitle1" sx={{ marginBottom: '40px' }}>
                  AI interview score
                </Typography>
                <ScoreFilters
                  setFilterAPICode={setFilterAPICode}
                  FiltersMap={FiltersMap}
                  reset={reset}
                />
              </Stack>
            )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack className={classes.footerDiv}>
          <Stack className={classes.footerDivFirst}>
            <Button
              disabled={resultsCount === 0}
              variant="contained"
              onClick={() => {
                handleViewResults();
              }}
            >
              View results
            </Button>
            <Typography variant="paragraph" sx={{ margin: 0 }}>
              {resultsCount} results
            </Typography>
          </Stack>
          <Typography
            variant="input"
            sx={{ fontSize: '16px', fontWeight: 500, cursor: 'pointer' }}
            onClick={() => setReset(prev => !prev)}
          >
            Clear all
          </Typography>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}

FiltersDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  filters: PropTypes.string,
  organization_id: PropTypes.string,
  jobId: PropTypes.string,
  setFilteredCandidateList: PropTypes.func,
  setShowFilterResults: PropTypes.func,
  setShowNavbar: PropTypes.func,
};
